// extracted by mini-css-extract-plugin
export default {"ProductCart":"ProductCart_ProductCart__eHC3p","SingleProduct":"ProductCart_SingleProduct__hTIr-","buttons":"ProductCart_buttons__xFbpJ","empty":"ProductCart_empty__WCHPQ"};